/* Salty Dogs Crew · carruseles con trackpad.
   Los sliders del tema (hdt-slider, Embla) se mueven arrastrando o con las
   flechas, pero ignoran el gesto horizontal del trackpad (eventos wheel con
   deltaX). Acá un deslizamiento hacia los costados sobre un carrusel pasa a
   la tarjeta siguiente o anterior, con una pausa corta para que un solo gesto
   no salte varias. Los carruseles con scroll nativo (Momentos, medios de
   pago) no pasan por acá: el navegador ya los desliza solo. */
(function () {
  var PAUSA = 420, ultimo = 0;
  document.addEventListener('wheel', function (e) {
    var dx = e.deltaX, dy = e.deltaY;
    if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy)) return;   /* gesto vertical: scroll normal */
    var s = e.target.closest && e.target.closest('hdt-slider');
    if (!s || typeof s.goToIndex !== 'function') return;
    e.preventDefault();                                             /* que el navegador no haga "atrás/adelante" */
    var ahora = Date.now();
    if (ahora - ultimo < PAUSA) return;
    ultimo = ahora;
    /* Preferimos la flecha del propio carrusel: avanza "de a pantalla" igual que
       el click (goToIndex va de a una tarjeta, y con varias a la vista no se mueve) */
    var nombre = dx > 0 ? 'next' : 'prev';
    var flecha = (s.id && document.querySelector('button[name="' + nombre + '"][aria-controls="' + s.id + '"]')) || s.querySelector('button[name="' + nombre + '"]');
    if (flecha) { flecha.click(); return; }
    var slides = s.querySelectorAll('.hdt-slider__slide'), actual = -1, i;
    for (i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-selected')) { actual = i; break; }
    if (actual < 0) return;
    s.goToIndex(actual + (dx > 0 ? 1 : -1));
  }, { passive: false });
})();
